import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1aaf97c1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "about-me",
  class: "about_me_section",
  "aria-describedby": "about Job Oaikhenah"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Fullstack Software Engineer with 5 years of experience developing scalable web applications across both frontend and backend. I take a horizontal, user-centered approach to software development and have delivered impactful solutions across multiple industries, supporting applications with large and growing user bases. ", -1))
const _hoisted_3 = { class: "about-me-portrait" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "highlights" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_action_button = _resolveComponent("action-button")!
  const _component_section_header = _resolveComponent("section-header")!
  const _component_highlight = _resolveComponent("highlight")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_section_header, null, {
      paragraph: _withCtx(() => [
        _hoisted_2
      ]),
      action: _withCtx(() => [
        _createVNode(_component_action_button, {
          btnType: "link",
          target: "_blank",
          href: "https://docs.google.com/document/d/1HgR4QD6E-mQFEF4kpsP_FJBX5NgO69x0_Tvbr4G-3Qw/edit?usp=sharing",
          download: "Job Oaikhenah's resumé"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Download my resumé")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(" About Me ")
      ]),
      _: 1
    }),
    _createElementVNode("figure", null, [
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("img", {
          src: require(`@/assets/images/job.jpg`),
          width: "808px",
          height: "493px",
          alt: "A picture of Job",
          loading: "lazy",
          decoding: "async"
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("article", _hoisted_5, [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Highlights, (highlight) => {
          return (_openBlock(), _createBlock(_component_highlight, {
            key: highlight.id,
            id: highlight.id,
            icon: highlight.icon,
            name: highlight.name,
            article: highlight.article
          }, null, 8, ["id", "icon", "name", "article"]))
        }), 128))
      ])
    ])
  ]))
}